import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from '../utils/posAxios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getPayment } from '../utils/dropdownlist';

class PosScheduleSlotDayForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      allow_onlymod: '',
      slot_id: '',
      schedule_id: '',
      starttime: '',
      endtime: '',
      max_slot: '',
      mon: 0,
      tue: 0,
      wed: 0,
      thurs: 0,
      fri: 0,
      sat: 0,
      sun: 0,
    };
  }

  componentDidMount() {
    console.log(this.props.data);
    let data = this.props.data;
    let slot_data = this.props.data.slot.find(
      x => x.slot_id === this.props.data.selectedId,
    );
    console.log(slot_data);
    this.setState({
      isEdit: data.isEdit,
      slot_id: data.selectedId,
      schedule_id: data.schedule_id,
      mon: slot_data.mon,
      tue: slot_data.tue,
      wed: slot_data.wed,
      thurs: slot_data.thurs,
      fri: slot_data.fri,
      sat: slot_data.sat,
      sun: slot_data.sun,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkHandler = event => {
    let { name } = event.target;
    this.setState({
      [name]: !this.state[name],
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    this.editDay(user, comp, url);
  };

  editDay(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      slot_id: this.state.slot_id,
      mon: this.state.mon,
      tue: this.state.tue,
      wed: this.state.wed,
      thurs: this.state.thurs,
      fri: this.state.fri,
      sat: this.state.sat,
      sun: this.state.sun,
      update_by: user.email,
    };

    axios
      .post(url + ':3001/v1/schedule/slots/day', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Day updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Edit Day</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="mon"
                    checked={this.state.mon}
                    onChange={this.checkHandler}
                  />
                  Mon
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="tue"
                    checked={this.state.tue}
                    onChange={this.checkHandler}
                  />
                  Tue
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="wed"
                    checked={this.state.wed}
                    onChange={this.checkHandler}
                  />
                  Wed
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="thurs"
                    checked={this.state.thurs}
                    onChange={this.checkHandler}
                  />
                  Thurs
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="fri"
                    checked={this.state.fri}
                    onChange={this.checkHandler}
                  />
                  Fri
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="sat"
                    checked={this.state.sat}
                    onChange={this.checkHandler}
                  />
                  Sat
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input
                    type="checkbox"
                    name="sun"
                    checked={this.state.sun}
                    onChange={this.checkHandler}
                  />
                  Sun
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosScheduleSlotDayForm;
